/**
 * Navigation Commands Registry
 *
 * Statik navigation komutları tanımları
 * Her komut bir sayfaya yönlendirir
 */

import { ShoppingCart, Home, Sparkles, Library } from "lucide-react";
import { HarmonyWardrobe } from "@/components/icons";
import { fashionPaths, modelsPaths } from "@/modules";
import type { SlashCommand } from "../types/command-types";

export const navigationCommands: SlashCommand[] = [
  {
    id: "nav-home",
    trigger: "/home",
    label: "slashCommands.home",
    description: "slashCommands.homeDesc",
    icon: <Home className="h-5 w-5" />,
    shortcut: "/h",
    type: "navigation",
    path: "/",
  },
  {
    id: "nav-cart",
    trigger: "/cart",
    label: "slashCommands.cart",
    description: "slashCommands.cartDesc",
    icon: <ShoppingCart className="h-5 w-5" />,
    shortcut: "/c",
    type: "navigation",
    path: "/cart",
  },
  {
    id: "nav-wardrobe",
    trigger: "/wardrobe",
    label: "slashCommands.wardrobe",
    description: "slashCommands.wardrobeDesc",
    icon: <HarmonyWardrobe className="h-5 w-5" />,
    shortcut: "/w",
    type: "navigation",
    path: fashionPaths.wardrobe(),
  },
  {
    id: "nav-my-wardrobe",
    trigger: "/my-wardrobe",
    label: "slashCommands.myWardrobe",
    description: "slashCommands.myWardrobeDesc",
    icon: <HarmonyWardrobe className="h-5 w-5" />,
    type: "navigation",
    path: fashionPaths.myWardrobe(),
  },
  {
    id: "nav-shopping",
    trigger: "/shopping",
    label: "slashCommands.shopping",
    description: "slashCommands.shoppingDesc",
    icon: <ShoppingCart className="h-5 w-5" />,
    shortcut: "/s",
    type: "navigation",
    path: fashionPaths.shop(),
  },
  {
    id: "nav-ai-models",
    trigger: "/ai-models",
    label: "slashCommands.aiModels",
    description: "slashCommands.aiModelsDesc",
    icon: <Sparkles className="h-5 w-5" />,
    shortcut: "/ai",
    type: "navigation",
    path: modelsPaths.root(),
  },
  {
    id: "nav-library",
    trigger: "/library",
    label: "slashCommands.library",
    description: "slashCommands.libraryDesc",
    icon: <Library className="h-5 w-5" />,
    shortcut: "/l",
    type: "navigation",
    path: modelsPaths.library(),
  },
];
